import BigNum from "../../../model/math/BigNum";
import Statistics from "../../../model/statistics/Statistics";
import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import TimeFormatter from "../../../util/TimeFormatter";
import Page from "../../framework/Page";
import View from "../../framework/View";

export default class StatisticsView extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {Statistics} statistics
     * @param {string} headerText
     */
    constructor(parentId, elementId, statistics, headerText) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {Statistics}
         */
        this.statistics = statistics;

        /**
         * @constant
         * @type {string}
         */
        this.headerText = headerText;

        /**
         * @constant
         * @type {number}
         */
        this.displayedSeconds = -1;
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTotalOre = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTotalGold = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTotalRuby = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTotalPrestigePoints = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedUpgradeOre = new BigNum(-1);

        /**
         * @type {number}
         */
        this.displayedMaxDepth = -1;

        ///////////////////////////////////////
        // Total blocks mined
        ///////////////////////////////////////

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMined = new BigNum(-1);

        ///////////////////////////////////////
        // Blocks by type
        ///////////////////////////////////////

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedCommon = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedOre = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedGold = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedRuby = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedUpgrade = new BigNum(-1);


        ///////////////////////////////////////
        // Blocks by skill
        ///////////////////////////////////////

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedLaser = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedDrill = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedOrbit = new BigNum(-1);
        // /**
        //  * @constant
        //  * @type {BigNum}
        //  */
        // this.displayedTilesMinedFissure = new BigNum(-1);
        // /**
        //  * @constant
        //  * @type {BigNum}
        //  */
        // this.displayedTilesMinedLightning = new BigNum(-1);
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTilesMinedMissile = new BigNum(-1);


        /**
         * @type {HTMLElement}
         */
        this.totalTurnsElement = null;
        /**
         * @type {HTMLElement}
         */
        this.totalOreElement = null;
        /**
         * @type {HTMLElement}
         */
        this.totalGoldElement = null;
        /**
         * @type {HTMLElement}
         */
        this.totalRubyElement = null;
        /**
         * @type {HTMLElement}
         */
        this.totalPrestigePointsElement = null;

        /**
         * @type {HTMLElement}
         */
        this.upgradeOreElement = null;
        
        /**
         * @type {HTMLElement}
         */
        this.maxDepthElement = null;

        ///////////////////////////////////////
        // Total blocks mined
        ///////////////////////////////////////

        /**
         * @type {HTMLElement}
         */
        this.tilesMinedElement = null;

        ///////////////////////////////////////
        // Blocks by type
        ///////////////////////////////////////

        /**
         * @type {HTMLElement}
         */
        this.tilesMinedCommonElement = null;
        /**
         * @type {HTMLElement}
         */
        this.tilesMinedOreElement = null;
        /**
         * @type {HTMLElement}
         */
        this.tilesMinedGoldElement = null;
        /**
         * @type {HTMLElement}
         */
        this.tilesMinedRubyElement = null;
        /**
         * @type {HTMLElement}
         */
        this.tilesMinedUpgradeElement = null;


        ///////////////////////////////////////
        // Blocks by skill
        ///////////////////////////////////////


        /**
         * @type {HTMLElement}
         */
        this.tilesMinedLaserElement = null;
        /**
         * @type {HTMLElement}
         */
        this.tilesMinedDrillElement = null;
        /**
         * @type {HTMLElement}
         */
        this.tilesMinedOrbitElement = null;
        // /**
        //  * @type {HTMLElement}
        //  */
        // this.tilesMinedFissureElement = null;
        // /**
        //  * @type {HTMLElement}
        //  */
        // this.tilesMinedLightningElement = null;
        /**
         * @type {HTMLElement}
         */
        this.tilesMinedMissileElement = null;

        this.setViewVisible(false);
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {

        // <div id="statisticsPopup" class="popup-window-statistics" style="display: none;">

        const parentElement = Page.getElement(this.parentId);

        const statsContainer = Page.createElement('div', parentElement, null, 'stats-view');

        // <div class="popup-window-header">
        //   Statistics
        // </div>

        const statsHeader = Page.createElement('div', statsContainer, null, 'stats-header');
        statsHeader.innerHTML = this.headerText;

        // const thisRef = this;

        // statsHeader.onclick = function () {
        //     thisRef.setViewVisible(false);
        //     return false;
        // };


        // <div class="menu-section-body">

        const sectionBody = Page.createElement('div', statsContainer, null, 'menu-section-body');

        //   <div class="numbers-section-row">
        //     <div class="numbers-section-label">Total Ore</div>
        //     <div class="numbers-section-unit">Ore</div>
        //     <div id="statsTotalOre" class="numbers-section-value">0</div>
        //   </div>

        this.totalTurnsElement = this.createStatsSection(sectionBody, 'Time', 'Time', false);

        this.totalOreElement = this.createStatsSection(sectionBody, 'Total Ore', 'Ore', false);

        this.totalGoldElement = this.createStatsSection(sectionBody, 'Total Gold', 'Gold', false);

        this.totalRubyElement = this.createStatsSection(sectionBody, 'Total Ruby', 'Ruby', false);

        this.totalPrestigePointsElement = this.createStatsSection(sectionBody, 'Total Prestige', 'Points', false);

        this.maxDepthElement = this.createStatsSection(sectionBody, 'Max Depth', 'Blocks', false);

        this.upgradeOreElement = this.createStatsSection(sectionBody, 'Upgrade Ore', 'Ore', false);

        ///////////////////////////////////////
        // Total blocks mined
        ///////////////////////////////////////

        this.tilesMinedElement = this.createStatsSection(sectionBody, 'Type: Any', 'Blocks', true);

        ///////////////////////////////////////
        // Blocks by type
        ///////////////////////////////////////

        this.tilesMinedCommonElement = this.createStatsSection(sectionBody, 'Type: Common', 'Blocks', false);
        this.tilesMinedOreElement = this.createStatsSection(sectionBody, 'Type: Ore', 'Blocks', false);
        this.tilesMinedGoldElement = this.createStatsSection(sectionBody, 'Type: Gold', 'Blocks', false);
        this.tilesMinedRubyElement = this.createStatsSection(sectionBody, 'Type: Ruby', 'Blocks', false);
        this.tilesMinedUpgradeElement = this.createStatsSection(sectionBody, 'Type: Upgrade', 'Blocks', false);

        ///////////////////////////////////////
        // Blocks by skill
        ///////////////////////////////////////

        this.tilesMinedLaserElement = this.createStatsSection(sectionBody, 'Skill: Laser', 'Blocks', true);
        this.tilesMinedDrillElement = this.createStatsSection(sectionBody, 'Skill: Drill', 'Blocks', false);
        this.tilesMinedOrbitElement = this.createStatsSection(sectionBody, 'Skill: Orbit', 'Blocks', false);
        //this.tilesMinedLightningElement = this.createStatsSection(sectionBody, 'Skill: Lightning', 'Blocks', false);
        //this.tilesMinedFissureElement = this.createStatsSection(sectionBody, 'Skill: Fissure', 'Blocks', false);
        this.tilesMinedMissileElement = this.createStatsSection(sectionBody, 'Skill: Missile', 'Blocks', false);

        this.setInitialVisibility(true);

        super.initializeView();
    }

    /**
     * @private
     * @param {HTMLElement} parent 
     * @param {string} label
     * @param {string} unit
     * @param {boolean} newSection
     * @returns {HTMLElement}
     */
    createStatsSection(parent, label, unit, newSection) {
        //   <div class="numbers-section-row">
        //     <div class="numbers-section-label">Total Ore</div>
        //     <div class="numbers-section-unit">Ore</div>
        //     <div id="statsTotalOre" class="numbers-section-value">0</div>
        //   </div>

        // Section separator:
        // <div class="numbers-section-row" style="margin-top: 10px;">

        const statsSection = Page.createElement('div', parent, null, 'numbers-section-row');

        if (newSection) {
            statsSection.style.marginTop = '10px';
        }

        const labelElement = Page.createElement('div', statsSection, null, 'numbers-section-label');
        labelElement.innerHTML = label;

        const unitElement = Page.createElement('div', statsSection, null, 'numbers-section-unit');
        unitElement.innerHTML = unit;

        return Page.createElement('div', statsSection, null, 'numbers-section-value');
    }

    /**
     * @override
     */
    updateViewContents() {

        const seconds = (this.statistics.totalTurns * Settings.time.secondsPerTurn) | 0;
        if (this.displayedSeconds !== seconds) {
            this.displayedSeconds = seconds;
            this.totalTurnsElement.innerHTML = TimeFormatter.formatElapsedTime(seconds * 1000);
        }

        const totalOre = this.statistics.totalOre;
        if (!this.displayedTotalOre.equals(totalOre)) {
            this.displayedTotalOre.copy(totalOre);
            this.totalOreElement.innerHTML = NumberFormatter.formatBigNum(totalOre);
        }

        const totalGold = this.statistics.totalGold;
        if (!this.displayedTotalGold.equals(totalGold)) {
            this.displayedTotalGold.copy(totalGold);
            this.totalGoldElement.innerHTML = NumberFormatter.formatBigNum(totalGold);
        }

        const totalRuby = this.statistics.totalRuby;
        if (!this.displayedTotalRuby.equals(totalRuby)) {
            this.displayedTotalRuby.copy(totalRuby);
            this.totalRubyElement.innerHTML = NumberFormatter.formatBigNum(totalRuby);
        }

        const totalPrestigePoints = this.statistics.totalPrestigePoints;
        if (!this.displayedTotalPrestigePoints.equals(totalPrestigePoints)) {
            this.displayedTotalPrestigePoints.compare(totalPrestigePoints);
            this.totalPrestigePointsElement.innerHTML = NumberFormatter.formatBigNum(totalPrestigePoints);
        }

        const upgradeOre = this.statistics.upgradeOre;
        if (!this.displayedUpgradeOre.equals(upgradeOre)) {
            this.displayedUpgradeOre.copy(upgradeOre);
            this.upgradeOreElement.innerHTML = NumberFormatter.formatBigNum(upgradeOre);
        }

        const maxDepth = this.statistics.maxDepth;
        if (this.displayedMaxDepth !== maxDepth) {
            this.displayedMaxDepth = maxDepth;
            this.maxDepthElement.innerHTML = NumberFormatter.formatNumber(maxDepth);
        }

        ///////////////////////////////////////
        // Total blocks mined
        ///////////////////////////////////////

        const tilesMined = this.statistics.tilesMined;
        if (!this.displayedTilesMined.equals(tilesMined)) {
            this.displayedTilesMined.copy(tilesMined);
            this.tilesMinedElement.innerHTML = NumberFormatter.formatBigNum(tilesMined);
        }

        ///////////////////////////////////////
        // Blocks by type
        ///////////////////////////////////////

        const tilesMinedCommon = this.statistics.tilesMinedCommon;
        if (!this.displayedTilesMinedCommon.equals(tilesMinedCommon)) {
            this.displayedTilesMinedCommon.copy(tilesMinedCommon);
            this.tilesMinedCommonElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedCommon);
        }

        const tilesMinedOre = this.statistics.tilesMinedOre;
        if (!this.displayedTilesMinedOre.equals(tilesMinedOre)) {
            this.displayedTilesMinedOre.copy(tilesMinedOre);
            this.tilesMinedOreElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedOre);
        }

        const tilesMinedGold = this.statistics.tilesMinedGold;
        if (!this.displayedTilesMinedGold.equals(tilesMinedGold)) {
            this.displayedTilesMinedGold.copy(tilesMinedGold);
            this.tilesMinedGoldElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedGold);
        }

        const tilesMinedRuby = this.statistics.tilesMinedRuby;
        if (!this.displayedTilesMinedRuby.equals(tilesMinedRuby)) {
            this.displayedTilesMinedRuby.copy(tilesMinedRuby);
            this.tilesMinedRubyElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedRuby);
        }

        const tilesMinedUpgrade = this.statistics.tilesMinedUpgrade;
        if (!this.displayedTilesMinedUpgrade.equals(tilesMinedUpgrade)) {
            this.displayedTilesMinedUpgrade.copy(tilesMinedUpgrade);
            this.tilesMinedUpgradeElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedUpgrade);
        }

        ///////////////////////////////////////
        // Blocks by skill
        ///////////////////////////////////////

        const tilesMinedLaser = this.statistics.tilesMinedLaser;
        if (!this.displayedTilesMinedLaser.equals(tilesMinedLaser)) {
            this.displayedTilesMinedLaser.copy(tilesMinedLaser);
            this.tilesMinedLaserElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedLaser);
        }

        const tilesMinedDrill = this.statistics.tilesMinedDrill;
        if (!this.displayedTilesMinedDrill.equals(tilesMinedDrill)) {
            this.displayedTilesMinedDrill.copy(tilesMinedDrill);
            this.tilesMinedDrillElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedDrill);
        }

        const tilesMinedOrbit = this.statistics.tilesMinedOrbit;
        if (!this.displayedTilesMinedOrbit.equals(tilesMinedOrbit)) {
            this.displayedTilesMinedOrbit.copy(tilesMinedOrbit);
            this.tilesMinedOrbitElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedOrbit);
        }

        // const tilesMinedLightning = this.statistics.tilesMinedLightning;
        // if (!this.displayedTilesMinedLightning.equals(tilesMinedLightning)) {
        //     this.displayedTilesMinedLightning.copy(tilesMinedLightning);
        //     this.tilesMinedLightningElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedLightning);
        // }

        // const tilesMinedFissure = this.statistics.tilesMinedFissure;
        // if (!this.displayedTilesMinedFissure.equals(tilesMinedFissure)) {
        //     this.displayedTilesMinedFissure.copy(tilesMinedFissure);
        //     this.tilesMinedFissureElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedFissure);
        // }

        const tilesMinedMissile = this.statistics.tilesMinedMissile;
        if (!this.displayedTilesMinedMissile.equals(tilesMinedMissile)) {
            this.displayedTilesMinedMissile.copy(tilesMinedMissile);
            this.tilesMinedMissileElement.innerHTML = NumberFormatter.formatBigNum(tilesMinedMissile);
        }
    }
    
}